import React from "react";
import Wrapper from "../../../components/Wrapper/Wrapper";
import { Box, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getProjectPackages } from "../../../redux/features/mastersSlice";
import { useState } from "react";
import { PROJECT_CLASSES_TABLE_HEAD } from "../../../components/Masters/ProjectPackagesTableHead";
import { AddProjectClassPopup } from "../../../components/Masters/AddProjectClassPopup";
import { AddProjectPackages } from "../../../components/Masters/AddProjectPackages";

export default function ProjectPackeges() {
    const dispatch = useDispatch();
    const [gridSize, setGridSize] = useState(5);
    const data = useSelector((state) => state.masters);

    useEffect(() => {
        dispatch(getProjectPackages());
    }, []);
    return (
        <div>
            <Wrapper
                title="Projects Packages"
                actions={<AddProjectPackages />}
                Content={
                    <>
                        <Paper elevation={3}>
                            <Box sx={{ width: "100%", padding: 0 }}>
                                <DataGrid
                                    components={{ Toolbar: CustomGridToolbar }}
                                    loading={data.loading}
                                    autoHeight
                                    sx={{
                                        "& .MuiDataGrid-columnHeaderTitle": {
                                            textOverflow: "clip",
                                            whiteSpace: "break-spaces",
                                            lineHeight: 1,
                                        },
                                    }}
                                    getRowHeight={() => "auto"}
                                    rows={data.projectPackages}
                                    columns={PROJECT_CLASSES_TABLE_HEAD}
                                    getRowId={(row) => row.serialNumber}
                                    pageSize={gridSize}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    onPageSizeChange={(newGridSize) =>
                                        setGridSize(newGridSize)
                                    }
                                />
                            </Box>
                        </Paper>
                    </>
                }
            />
        </div>
    );
}
